import React from 'react';
import { BarChart3, Network, Zap, GitBranch } from 'lucide-react';
export function PlatformTeaser() {
  const features = [{
    title: 'Org Visualisation',
    icon: Network,
    description: 'See your structure through the ATD lens. Visualise dependencies and boundaries instantly.'
  }, {
    title: 'Team Analytics',
    icon: BarChart3,
    description: 'Measure health at every level. Identify overloaded Atoms or bloated Cells.'
  }, {
    title: 'Structure Recommendations',
    icon: Zap,
    description: 'AI-powered suggestions to optimise your hierarchy based on communication patterns.'
  }, {
    title: 'Growth Planning',
    icon: GitBranch,
    description: 'Model future states. Simulate how your org looks with 50 more engineers.'
  }];
  return <section id="platform" className="py-20 bg-gradient-to-br from-indigo-600 to-purple-700 text-white overflow-hidden relative" data-id="element-244">
      {/* Background patterns */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden opacity-10 pointer-events-none" data-id="element-245">
        <div className="absolute top-10 left-10 w-64 h-64 rounded-full bg-white blur-3xl" data-id="element-246"></div>
        <div className="absolute bottom-10 right-10 w-96 h-96 rounded-full bg-pink-500 blur-3xl" data-id="element-247"></div>
      </div>

      <div className="container mx-auto px-4 max-w-6xl relative z-10" data-id="element-248">
        <div className="flex flex-col lg:flex-row items-center gap-12" data-id="element-249">
          <div className="lg:w-1/2 text-center lg:text-left" data-id="element-250">
            <div className="inline-block px-3 py-1 rounded-full bg-white/10 border border-white/20 text-sm font-medium mb-6 backdrop-blur-sm" data-id="element-251">
              Coming Soon
            </div>
            <h2 className="text-3xl md:text-5xl font-bold mb-6" data-id="element-252">
              The ATD Platform
            </h2>
            <p className="text-indigo-100 text-lg md:text-xl mb-8 leading-relaxed" data-id="element-253">
              We're building the operating system for modern engineering
              organisations. Move beyond static org charts to a living,
              breathing model of your team.
            </p>
            <button onClick={() => document.getElementById('waitlist')?.scrollIntoView({
            behavior: 'smooth'
          })} className="bg-white text-indigo-600 px-8 py-4 rounded-lg font-bold text-lg hover:bg-indigo-50 transition-colors shadow-lg" data-id="element-254">
              Get Early Access
            </button>
          </div>

          <div className="lg:w-1/2 grid grid-cols-1 sm:grid-cols-2 gap-4" data-id="element-255">
            {features.map((feature, index) => <div key={index} className="bg-white/10 backdrop-blur-md border border-white/10 p-6 rounded-xl hover:bg-white/20 transition-colors" data-id="element-256">
                <feature.icon className="h-8 w-8 text-pink-300 mb-4" data-id="element-257" />
                <h3 className="text-xl font-bold mb-2" data-id="element-258">{feature.title}</h3>
                <p className="text-indigo-100 text-sm leading-relaxed" data-id="element-259">
                  {feature.description}
                </p>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}